// Usage Statistics Tracker for Accessibility Widget

export class AccessibilityStats {
  constructor() {
    this.stats = this.loadStats();
  }

  loadStats() {
    const saved = localStorage.getItem('accessibilityStats');
    if (saved) {
      return JSON.parse(saved);
    }
    return {
      totalSessions: 0,
      featuresUsed: {
        contrast: 0,
        highlightLinks: 0,
        fontSize: 0,
        textSpacing: 0,
        pauseAnimations: 0,
        legibleFonts: 0,
        bigCursor: 0,
        lineHeight: 0,
        textAlign: 0,
        saturation: 0,
        hideImages: 0,
      },
      lastUsed: null,
      totalTimeSpent: 0,
      sessionStart: null,
    };
  }

  saveStats() {
    localStorage.setItem('accessibilityStats', JSON.stringify(this.stats));
  }

  startSession() {
    this.stats.totalSessions++;
    this.stats.sessionStart = Date.now();
    this.saveStats();
  }

  endSession() {
    if (this.stats.sessionStart) {
      const timeSpent = Date.now() - this.stats.sessionStart;
      this.stats.totalTimeSpent += timeSpent;
      this.stats.sessionStart = null;
      this.saveStats();
    }
  }

  trackFeatureUse(featureName) {
    if (this.stats.featuresUsed[featureName] !== undefined) {
      this.stats.featuresUsed[featureName]++;
      this.stats.lastUsed = Date.now();
      this.saveStats();
    }
  }

  getStats() {
    return {
      ...this.stats,
      totalTimeSpentMinutes: Math.round(this.stats.totalTimeSpent / 60000),
      mostUsedFeature: this.getMostUsedFeature(),
      averageSessionTime: this.stats.totalSessions > 0 
        ? Math.round(this.stats.totalTimeSpent / this.stats.totalSessions / 1000) 
        : 0,
    };
  }

  getMostUsedFeature() {
    const features = this.stats.featuresUsed;
    const entries = Object.entries(features);
    if (entries.length === 0) return null;
    
    const sorted = entries.sort((a, b) => b[1] - a[1]);
    return sorted[0][1] > 0 ? sorted[0][0] : null;
  }

  resetStats() {
    this.stats = {
      totalSessions: 0,
      featuresUsed: {
        contrast: 0,
        highlightLinks: 0,
        fontSize: 0,
        textSpacing: 0,
        pauseAnimations: 0,
        legibleFonts: 0,
        bigCursor: 0,
        lineHeight: 0,
        textAlign: 0,
        saturation: 0,
        hideImages: 0,
      },
      lastUsed: null,
      totalTimeSpent: 0,
      sessionStart: null,
    };
    this.saveStats();
  }

  exportStats() {
    return JSON.stringify(this.getStats(), null, 2);
  }
}

export default new AccessibilityStats();
